module.exports = __webpack_public_path__ + "static/media/toShoppingCart.b61ff7f4.svg";